import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-icon',
  imports: [],
  template: '<ng-content/>',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './icon.component.sass',
})
export class IconComponent {

}
